import 'url-search-params-polyfill'

import { createRoot } from 'react-dom/client'
import Root from './routes/root'
import ThemeProvider from 'providers/ThemeProvider'
import 'utils/i18n'
import './assets/css/index.css'
import 'moment/locale/ro'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { AreasWrapper } from './providers/AreasProvider'
import getTheme from './utils/theme'

import AuthApolloProvider from 'apollo/AuthApolloProvider'
import AuthProvider from 'providers/AuthenticationProvider'
import { liteMode } from 'features/chat/functions'

const theme = getTheme()
const container = document.getElementById('root')
Object.assign(container.style, { ...theme.typography.defaultFont, color: theme.palette.primary.main })
const root = createRoot(container)

const { env } = require('utils/env')
// if env.REACT_APP_WEBCHAT_IS_ANONYMOUS or url is /lite, we don't need to secure the route
const isAnonymous = JSON.parse(env.REACT_APP_WEBCHAT_IS_ANONYMOUS) || liteMode()

root.render(
  <ThemeProvider>
    <AreasWrapper>
      {isAnonymous ? (
        <Root />
      ) : (
        <AuthProvider>
          <AuthApolloProvider>
            <Root />
          </AuthApolloProvider>
        </AuthProvider>
      )}
    </AreasWrapper>
  </ThemeProvider>
)
